import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {createUseStyles} from 'react-jss'

export default function TooltipIconButton(props){

    const [optionsTooltip, setOptionsTooltip] = React.useState({});
    const [optionsButton, setOptionsButton] = React.useState({});
    const myRef = React.createRef();

    React.useEffect(() => {
        if (props.options.optionsTooltip) setOptionsTooltip(props.options.optionsTooltip);
        if (props.options.optionsButton) setOptionsButton(props.options.optionsButton);
    }, [props]);
    

    const useStyles = createUseStyles({
        show: {
            display: optionsButton.hidden ? 'none' : 'block'
        }
    });

    const classes = useStyles();

    return ( 
        
        <Tooltip ref={myRef} title={props.tooltip} placement="top" {...optionsTooltip} arrow>
            <div>
            <IconButton className={classes.show} color="inherit" onClick={() => props.onClick(optionsButton)} {...optionsButton}>
                {props.icon}
            </IconButton>
            </div>
        </Tooltip>
    )
}

TooltipIconButton.defaultProps = {
    tooltip: ''
    ,icon: null
    ,options: {}
    ,onClick: (options) => {}
}

TooltipIconButton.propTypes = {
    icon: PropTypes.object.isRequired
}